<template>
	<div class="detail-form">
		<div class="row" v-show="!isLoadingUsers">
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="userRole">Tipo de Usuário:</label>
				<GenericMultiselect
					class="detail-form__field--input"
					ref="userRole"
					:options="roleOptions"
					:placeholder="'Tipo de Usuário'"
					:fullWidth="!isWeb"
					:searchable="false"
					:clearOnOpen="false"
					:needType="true"
					:type="'userRole'"
					@changeInput="changeRoleInput"
				/>
			</div>
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="name">Nome:</label>
				<input
					class="detail-form__field--input"
					:class="[requiredFields.firstName ? 'alert' : '']"
					id="name"
					type="text"
					placeholder="Nome"
					v-model="user.firstName"
				/>
			</div>
		</div>
		<div class="row" v-show="!isLoadingUsers">
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="lastname">Sobrenome:</label>
				<input
					class="detail-form__field--input"
					:class="[requiredFields.lastName ? 'alert' : '']"
					id="lastname"
					type="text"
					placeholder="Sobrenome"
					v-model="user.lastName"
				/>
			</div>
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="originator">Código do País:</label>
				<input
					class="detail-form__field--input"
					:class="[requiredFields.countryCode ? 'alert' : '']"
					id="originator"
					type="text"
					placeholder="+55"
					v-model="user.countryCode"
					v-mask="'+####'"
				/>
				<small class="detail-form__field--input--required" v-if="requiredFields.countryCode">
					Campo obrigatório.
				</small>
			</div>
		</div>
		<div class="row" v-show="!isLoadingUsers">
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="phone">Telefone:</label>
				<input
					class="detail-form__field--input"
					:class="[requiredFields.phone ? 'alert' : '']"
					id="phone"
					type="text"
					placeholder="(11) 11111-2222"
					v-model="user.phone"
					v-mask="'(##) #####-####'"
				/>
				<small class="detail-form__field--input--required" v-if="requiredFields.phone">
					Campo obrigatório.
				</small>
			</div>
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="email">E-mail corporativo: *</label>
				<input
					class="detail-form__field--input"
					:class="[requiredFields.email ? 'alert' : '']"
					id="email"
					type="text"
					placeholder="email@email.com"
					v-model="user.email"
				/>
				<small class="detail-form__field--input--required" v-if="requiredFields.email">
					Campo obrigatório.
				</small>
			</div>
		</div>
		<div class="row" v-show="!isLoadingUsers">
			<div
				class="detail-form__field"
				v-if="user.roleId === userRoleEnum.INVESTOR || user.roleId === userRoleEnum.ADMINISTRATOR"
			>
				<label class="detail-form__field--label" for="company">Empresa: *</label>
				<GenericMultiselect
					class="detail-form__field--input"
					ref="investor"
					:options="investorOptions"
					:placeholder="'Nome da empresa'"
					:searchable="true"
					:fullWidth="true"
					:showIcon="false"
					:cacheInput="true"
					:requiredField="requiredFields.investor"
					:type="'investor'"
					@changeInput="changeInvestorInput"
					@getCachedValue="getCachedValue"
					@requestSearch="requestSearch"
					v-if="!showCompanyInput"
				/>
				<input
					class="detail-form__field--input"
					:class="[requiredFields.investor ? 'alert' : '']"
					placeholder="Nome da empresa"
					type="text"
					name="investor"
					id="investor-input"
					autocomplete="off"
					v-model="user.investor"
					v-else
					@input="requiredFields.investor = false"
				/>
				<small class="detail-form__field--input--required" v-if="requiredFields.investor">
					Campo obrigatório.
				</small>
			</div>
			<div class="detail-form__field" v-else-if="user.roleId === userRoleEnum.ORIGINATOR">
				<label class="detail-form__field--label" for="company">Empresa: *</label>
				<GenericMultiselect
					class="detail-form__field--input"
					:customClass="'mfaStatus'"
					ref="investor"
					:options="originatorOptions"
					:placeholder="'Nome da empresa'"
					:fullWidth="!isWeb"
					:searchable="true"
					:clearOnOpen="false"
					:needType="true"
					:showIcon="false"
					:type="'investor'"
					:requiredField="requiredFields.investor"
					@changeInput="changeInvestorInput"
				/>
				<small class="detail-form__field--input--required" v-if="requiredFields.investor">
					Campo obrigatório.
				</small>
			</div>
			<div class="detail-form__field" v-else-if="user.roleId === userRoleEnum.STRUCTURER">
				<label class="detail-form__field--label" for="company">Empresa: *</label>
				<GenericMultiselect
					class="detail-form__field--input"
					:customClass="'mfaStatus'"
					ref="investor"
					:options="structurerOptions"
					:placeholder="'Nome da empresa'"
					:fullWidth="!isWeb"
					:searchable="true"
					:clearOnOpen="false"
					:needType="true"
					:showIcon="false"
					:type="'investor'"
					:requiredField="requiredFields.investor"
					@changeInput="changeInvestorInput"
				/>
				<small class="detail-form__field--input--required" v-if="requiredFields.investor">
					Campo obrigatório.
				</small>
			</div>
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="role">Cargo:</label>
				<input
					class="detail-form__field--input"
					:class="[requiredFields.role ? 'alert' : '']"
					id="role"
					type="text"
					placeholder="Digite seu cargo"
					v-model="user.role"
				/>
				<small class="detail-form__field--input--required" v-if="requiredFields.role">
					Campo obrigatório.
				</small>
			</div>
		</div>
		<div class="row" v-show="!isLoadingUsers">
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="status">Status do Usuário:</label>
				<GenericMultiselect
					class="detail-form__field--input"
					:customClass="'status'"
					ref="status"
					:options="statusOptions"
					:placeholder="'Status'"
					:fullWidth="!isWeb"
					:searchable="false"
					:clearOnOpen="false"
					:needType="true"
					:type="'status'"
					@changeInput="changeStatusInput"
				/>
			</div>
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="mfaStatus"
					>Pedir 2º fator de autenticação?</label
				>
				<GenericMultiselect
					class="detail-form__field--input"
					:customClass="'mfaStatus'"
					ref="mfaStatus"
					:options="mfaOptions"
					:placeholder="'Selecionar opção'"
					:fullWidth="!isWeb"
					:searchable="false"
					:clearOnOpen="false"
					:needType="true"
					:type="'mfaStatus'"
					@changeInput="changeMfaStatusInput"
				/>
			</div>
		</div>
		<div class="row" v-show="!isLoadingUsers && newUser">
			<div class="detail-form__field">
				<label class="detail-form__field--label password" for="password">Senha: *</label>
				<InputPassword
					id="password-input"
					v-model="user.password"
					class="detail-form__field--input"
					:class="(validatedPasswords && user.password) || !user.password ? 'approved' : 'deny'"
					:alertClass="requiredFields.password && newUser"
					@clearRequired="requiredFields.password = false"
				/>
				<small
					class="detail-form__field--input--required"
					v-if="newUser && requiredFields.password"
				>
					Campo obrigatório.
				</small>
			</div>
			<div class="detail-form__field">
				<label class="detail-form__field--label password" for="confirm_password"
					>Confirmar Senha: *</label
				>
				<InputPassword
					id="password-input"
					v-model="confirmPassword"
					class="detail-form__field--input"
					:class="
						(validatedPasswords && requiredFields.confirmPassword) ||
						!requiredFields.confirmPassword
							? 'approved'
							: 'deny'
					"
					:alertClass="requiredFields.confirmPassword && newUser"
					@clearRequired="requiredFields.confirmPassword = false"
				/>
				<small
					class="detail-form__field--input--required"
					v-if="requiredFields.confirmPassword && newUser"
				>
					Campo obrigatório.
				</small>
			</div>
		</div>
		<div class="password-rules" v-if="!isLoadingUsers && newUser">
			<PasswordRules
				ref="passwordRules"
				:password="user.password"
				:confirmPassword="confirmPassword"
				:big="true"
			/>
		</div>
		<div class="detail-form__actions" :class="newUser ? 'new-user' : ''" v-show="!isLoadingUsers">
			<button
				class="detail-form__actions--btn outline"
				@click="handleDeleteModal()"
				v-if="!newUser"
			>
				Excluir Usuário
			</button>
			<button
				class="detail-form__actions--btn outline variant"
				:class="isLoadingSendEmail ? 'disabled' : ''"
				@click="handleResetPasswordModal()"
				v-if="!newUser"
			>
				Resetar senha
			</button>
			<div>
				<button class="detail-form__actions--btn" @click="validateFields()">Salvar</button>
			</div>
		</div>
		<div class="row justify-center align-center w-90-vw h-70-vh" v-if="isLoadingUsers">
			<SpinnerIcon />
		</div>
		<DeleteModal
			:title="'Excluir Tipo de Usuário'"
			:subtitle="'Tem certeza que deseja excluir o perfil do Usuário?'"
			:loader="isLoadingUsers"
			v-show="showDeleteModal"
			@handleDeleteModal="handleDeleteModal()"
			@confirmDelete="confirmDelete()"
		/>
		<ResetPasswordModal
			v-show="showResetPasswordModal"
			@handleResetPasswordModal="handleResetPasswordModal()"
			@sendEmail="sendEmail()"
			@handleNewPasswordModal="handleNewPasswordModal()"
		/>
		<NewPasswordModal
			v-show="showNewPasswordModal"
			@handleNewPasswordModal="handleNewPasswordModal()"
			@validateFields="validateFields()"
			@updateUserPassword="updateUserPassword"
			:requiredFields="requiredFields.password"
		/>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { GET_INVESTOR_REQUEST } from '@/store/modules/filters/investor/actions';
import { GET_STRUCTURER_REQUEST } from '@/store/modules/filters/structurer/actions';
import {
	GET_USER_BY_ID,
	CREATE_USER,
	UPDATE_USER,
	DELETE_USER,
	GET_ALL_ORIGINATORS,
	GET_USER_STATUS,
	GET_USER_ROLES,
} from '@/store/modules/userManagement/actions';
import { SEND_NEW_PASSWORD } from '@/store/modules/login/forgotPassword/actions';
import { mask } from 'vue-the-mask';
import CryptoJS from 'crypto-js';
import GenericMultiselect from '@/components/shared/GenericMultiselect/GenericMultiselect.vue';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon.vue';
import DeleteModal from '@/components/shared/DeleteModal/DeleteModal.vue';
import ResetPasswordModal from '@/components/modules/User/UserDetail/ResetPasswordModal/ResetPasswordModal.vue';
import InputPassword from '@/components/shared/InputPassword/InputPassword.vue';
import PasswordRules from '@/components/modules/Login/PasswordRules/PasswordRules.vue';
import NewPasswordModal from '@/components/modules/User/UserDetail/NewPasswordModal/NewPasswordModal.vue';
import UserRoleEnum from '@/enums/UserRoleEnum';

export default {
	name: 'UserForm',
	directives: { mask },
	components: {
		GenericMultiselect,
		SpinnerIcon,
		DeleteModal,
		InputPassword,
		PasswordRules,
		ResetPasswordModal,
		NewPasswordModal,
	},
	props: {
		isWeb: {
			required: true,
		},
	},
	data: () => ({
		user: {
			roleId: null,
			firstName: '',
			lastName: '',
			countryCode: '',
			phone: '',
			email: '',
			role: '',
			userStatus: '',
			userRole: '',
			mfaEnable: null,
			investor: '',
			investorId: null,
			password: '',
		},
		requiredFields: {
			email: false,
			userStatus: false,
			mfaEnable: false,
			investor: false,
			password: false,
			confirmPassword: false,
		},
		showDeleteModal: false,
		showResetPasswordModal: false,
		showNewPasswordModal: false,
		showCompanyInput: true,
		debounce: null,
		newUser: false,
		confirmPassword: '',
		userRoleEnum: null,
	}),
	created() {
		this.getAllOriginators({ vm: this });
		this.getStructurers({ vm: this });
		this.getUserStatus({ vm: this });
		this.getUserRoles({ vm: this });
	},
	beforeMount() {
		this.userRoleEnum = UserRoleEnum;
	},
	async mounted() {
		if (!this.$route.query.id) {
			this.newUser = true;
			return;
		}

		const res = await this.getUser({ vm: this, id: this.$route.query.id });

		const selectedUser = res.data;
		this.user.firstName = selectedUser.firstName;
		this.user.lastName = selectedUser.lastName;
		this.user.email = selectedUser.email;
		this.user.role = selectedUser.role;
		this.user.countryCode = selectedUser.countryCode;
		this.user.phone = selectedUser.phone;

		if (selectedUser.investor) {
			this.requestSearch(selectedUser.investor.name);
			this.user.investor = selectedUser.investor.name;
			this.user.investorId = selectedUser.investor.id;
		}

		if (selectedUser.userStatus) {
			this.user.userStatus = selectedUser.userStatus.id;
			this.$refs.status.setValue({
				id: selectedUser.userStatus.id,
				name: selectedUser.userStatus.name,
			});
		}

		if (selectedUser.userRoles) {
			this.user.userRole = selectedUser.userRoles.id;
			this.$refs.userRole.setValue({
				id: selectedUser.userRoles.id,
				name: selectedUser.userRoles.roleName,
			});
		}

		if (selectedUser.mfaEnable != null) {
			const mfaStatus = selectedUser.mfaEnable ? this.mfaOptions[0] : this.mfaOptions[1];
			this.$refs.mfaStatus.setValue(mfaStatus);
			this.user.mfaEnable = mfaStatus.id;
		}

		if (!selectedUser.userRoles) return;

		this.user.roleId = selectedUser.userRoles.id;

		if (selectedUser.userRoles.id === this.userRoleEnum.ORIGINATOR) {
			this.user.userRole = 'Originador';
			if (selectedUser.originator != null) {
				this.user.investor = selectedUser.originator.name;
				this.user.investorId = selectedUser.originator.id;
			}
			this.getAllOriginators({ vm: this }).then((res) => {
				if (selectedUser.originator != null) {
					this.$refs.investor.setValue({
						id: this.user.investorId,
						name: this.user.investor,
					});
				}
			});
		}

		if (selectedUser.userRoles.id === this.userRoleEnum.STRUCTURER) {
			this.user.userRole = 'Estruturador';
			if (selectedUser.structurer != null) {
				this.user.investor = selectedUser.structurer.name;
				this.user.investorId = selectedUser.structurer.id;
			}
			this.getStructurers({ vm: this }).then((res) => {
				if (selectedUser.structurer != null) {
					this.$refs.investor.setValue({
						id: this.user.investorId,
						name: this.user.investor,
					});
				}
			});
		}
	},
	methods: {
		...mapActions('forgotPassword', {
			sendNewPassword: SEND_NEW_PASSWORD,
		}),
		...mapActions('investor', { getInvestors: GET_INVESTOR_REQUEST }),
		...mapActions('structurer', { getStructurers: GET_STRUCTURER_REQUEST }),
		...mapActions('userManagement', {
			getUser: GET_USER_BY_ID,
			createUser: CREATE_USER,
			updateUser: UPDATE_USER,
			deleteUser: DELETE_USER,
			getAllOriginators: GET_ALL_ORIGINATORS,
			getUserStatus: GET_USER_STATUS,
			getUserRoles: GET_USER_ROLES,
		}),
		changeRoleInput(param) {
			this.user.userRole = param.value.name;
			this.user.roleId = param.value.id;
			this.user.investor = null;
			this.$refs.investor?.setValue();
		},
		changeStatusInput(param) {
			this.user.userStatus = param.value.id;
		},
		changeMfaStatusInput(param) {
			this.user.mfaEnable = param.value.id;
		},
		changeInvestorInput(param) {
			if (param && (param.name || param.value.name)) {
				this.user.investor = param.name || param.value.name;
				this.user.investorId = param.id || param.value.id;
				this.requiredFields.investor = false;
			}
		},
		requestSearch(param) {
			clearTimeout(this.debounce);
			const query = new URLSearchParams();
			query.set('search', param);

			this.debounce = setTimeout(() => {
				if (!param) return;

				this.getInvestors({ params: query.toString(), vm: this });
			}, 600);
		},
		getCachedValue(param) {
			if (param.length < 2) return;

			this.showCompanyInput = true;
			this.user.investor = param;
			this.user.investorId = null;
		},
		handleDeleteModal() {
			this.showDeleteModal = !this.showDeleteModal;
		},
		confirmDelete() {
			this.deleteUser({ vm: this, id: this.$route.query.id }).then((res) => {
				this.handleDeleteModal();
				if (res.status == 200) {
					this.$router.push({ path: '/dashboard/users' });
				}
			});
		},
		handleResetPasswordModal() {
			this.showResetPasswordModal = !this.showResetPasswordModal;
		},
		confirmUpdate() {
			let body = JSON.stringify(this.user);
			body = JSON.parse(body);

			if (!body.investorId) delete body.investorId;
			else delete body.investor;

			if (this.user.userRole === 'Originador') {
				body['originatorId'] = body.investorId;
				delete body.investorId;
			}

			if (this.user.userRole === 'Estruturador') {
				body['structurerId'] = body.investorId;
				delete body.investorId;
			}

			if (this.user.mfaEnable == null) delete body.mfaEnable;

			let timestamp = new Date().toISOString();
			let formatHour = this.$moment(new Date(timestamp)).format('HH:mm:ss');
			formatHour = formatHour.replace(new RegExp(':', 'g'), '');

			if (body.password) {
				const fixedKey = process.env.VUE_APP_FIXED_KEY;
				const getEmailChars = body.email.substring(0, 4);

				const key = `${fixedKey}${getEmailChars}${formatHour}`;
				const encryptedPassword = CryptoJS.AES.encrypt(body.password, key);

				body['password'] = encryptedPassword.toString();
			} else {
				delete body['password'];
			}
			this.updateUser({ vm: this, id: this.$route.query.id, body: body, timestamp: timestamp });
		},
		createNewUser() {
			let body = JSON.stringify(this.user);
			body = JSON.parse(body);

			const fixedKey = process.env.VUE_APP_FIXED_KEY;
			const getEmailChars = body.email.substring(0, 4);
			const userPassword = this.user.password;

			let timestamp = new Date().toISOString();
			let formatHour = this.$moment(new Date(timestamp)).format('HH:mm:ss');
			formatHour = formatHour.replace(/:/g, '');

			const key = `${fixedKey}${getEmailChars}${formatHour}`;
			const encryptedPassword = CryptoJS.AES.encrypt(userPassword, key);

			body['password'] = encryptedPassword.toString();

			if (!body.investorId) delete body.investorId;
			else delete body.investor;

			if (this.user.userRole === 'Originador') {
				body['originatorId'] = body.investorId;
				delete body.investorId;
				delete body.investor;
			}

			if (this.user.userRole === 'Estruturador') {
				body['structurerId'] = body.investorId;
				delete body.investorId;
				delete body.investor;
			}

			if (this.user.mfaEnable == null) delete body.mfaEnable;

			this.createUser({ vm: this, body: body, timestamp: timestamp }).then((res) => {
				if (res.status == 201) {
					this.$router.push({ path: '/dashboard/users' });
				}
			});
		},
		validateEmail(email) {
			let emailRegex = /\S+@\S+\.\S+/;
			return emailRegex.test(email);
		},
		validatedPasswords() {
			return this.$refs.passwordRules.validatedPasswords();
		},
		validateFields() {
			this.requiredFields = {
				email: true,
				investor: true,
				password: false,
				confirmPassword: false,
			};

			if (this.newUser) {
				this.requiredFields.password = true;
				this.requiredFields.confirmPassword = true;
			}

			if (this.user.email) this.requiredFields.email = false;
			if (this.user.investor) this.requiredFields.investor = false;
			if (this.user.password) this.requiredFields.password = false;
			if (this.confirmPassword) this.requiredFields.confirmPassword = false;

			if (!this.user.email || !this.user.investor) {
				return;
			}

			if (this.newUser) {
				if (!this.user.password || !this.confirmPassword) {
					return;
				} else if (this.user.password !== this.confirmPassword) {
					return this.$toastr.e('As senhas precisam ser iguais.');
				}
			}

			if (!this.validateEmail(this.user.email)) {
				return this.$toastr.e('Email inválido.');
			}

			if (!this.newUser) {
				this.confirmUpdate();
			} else {
				this.createNewUser();
			}
		},
		sendEmail() {
			const body = {
				email: this.user.email.trim(),
			};
			this.handleResetPasswordModal();
			this.sendNewPassword({ body: body, vm: this }).then((res) => {
				if (res.status === 201) {
					this.$toastr.s('Email de recuperação de senha enviado com sucesso');
				}
			});
		},
		handleNewPasswordModal() {
			this.showNewPasswordModal = !this.showNewPasswordModal;
		},
		updateUserPassword(param) {
			this.user.password = param;
			this.confirmPassword = param;
		},
	},
	computed: {
		...mapGetters('userManagement', [
			'isLoadingUsers',
			'originatorList',
			'statusList',
			'userRoleList',
		]),
		...mapGetters('investor', ['investorList']),
		...mapGetters('structurer', ['structurerList']),
		...mapGetters('forgotPassword', ['isLoadingSendEmail']),
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
		investorOptions() {
			const options = this.investorList != undefined ? this.investorList : [];

			return !options.length ? [] : options;
		},
		originatorOptions() {
			const options = this.originatorList != undefined ? this.originatorList : [];

			return !options.length ? [] : options;
		},
		structurerOptions() {
			const options = this.structurerList != undefined ? this.structurerList : [];

			return !options.length ? [] : options;
		},
		roleOptions() {
			const options =
				this.userRoleList != undefined
					? this.userRoleList.map((r) => ({ id: r.id, name: r.roleName }))
					: [];

			return !options.length ? [] : options;
		},
		statusOptions() {
			const options = this.statusList != undefined ? this.statusList : [];

			return !options.length ? [] : options;
		},
		mfaOptions() {
			return [
				{
					id: true,
					name: 'Sim',
				},
				{
					id: false,
					name: 'Não',
				},
			];
		},
	},
	watch: {
		'user.investor'(newValue) {
			if (!newValue || newValue.length == 1) {
				this.showCompanyInput = false;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'UserForm.scss';
</style>
